'use client';

import React from 'react';
import { Typography } from '@unity/cloud-ui';
import { Mermaid } from '../mermaid';

export const PreformattedText = (props: React.PropsWithChildren<{ title?: string }>) => {
  const { title, children } = props;

  // @ts-expect-error Property 'props' does not exist on type 'Iterable<ReactNode>'.
  const isMermaid = typeof children === 'object' && children?.props?.className === 'language-mermaid';

  if (isMermaid) {
    return (
      // @ts-expect-error Property 'props' does not exist on type 'Iterable<ReactNode>'.
      <Mermaid>{children.props.children}</Mermaid>
    );
  }

  return (
    <Typography component="pre" variant="body2" {...props}>
      {React.Children.map(children, (child) => {
        if (!React.isValidElement(child)) {
          return null;
        }
        return React.cloneElement(child, {
          // @ts-expect-error title does not exist on unknown child type
          title,
        });
      })}
    </Typography>
  );
};
